<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" sm="12" md="2" class="text-right" style="margin-left: 81%">
          <b-button variant="primary" @click="pdfExport">
              {{  $t('globalTrans.export_pdf') }}
          </b-button>
      </b-col>
      <b-col lg="12" sm="12">
        <iq-card>
           <template v-slot:body>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.follow_up_progress') }}
                  </h5>
                </div>
              </template>
              <b-table-simple bordered>

                    <b-tr>
                        <b-th>{{ $t('social_service.follow_up_no') }}</b-th>
                        <b-td>{{ $n(followup_mains.follow_up_no, { useGrouping: false }) }}</b-td>
                        <b-th>{{ $t('social_service.follow_up_date') }}</b-th>
                        <b-td>{{ followup_mains.follow_up_date | dateFormat }}</b-td>
                        <b-th>{{ $t('social_service.mobile_no') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.phone_no | mobileNumber }}</b-td>
                    </b-tr>

                    <b-tr>
                        <b-th>{{ $t('social_service.help_desc_en') }}</b-th>
                        <b-td>{{ followup_mains.help_description }}</b-td>
                        <b-th>{{ $t('social_service.help_desc_bn') }}</b-th>
                        <b-td>{{ followup_mains.help_description_bn }}</b-td>
                        <b-th>{{ $t('social_service.helping_date') }}</b-th>
                        <b-td>{{ followup_mains.helping_date | dateFormat }}</b-td>
                    </b-tr>

                    <b-tr>
                        <b-th>{{ $t('social_service.supporting_authority_en') }}</b-th>
                        <b-td>{{ followup_mains.support_authority }}</b-td>
                        <b-th>{{ $t('social_service.supporting_authority_bn') }}</b-th>
                        <b-td>{{ followup_mains.support_authority_bn }}</b-td>
                        <b-th>{{ $t('social_service.patient_en') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.patient_name }}</b-td>
                    </b-tr>

                    <b-tr>
                        <b-th>{{ $t('social_service.patient_bn') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.patient_name_bn }}</b-td>
                        <b-th>{{ $t('social_service.register_nid') }}</b-th>
                        <b-td>{{ followup_mains.nid_no | mobileNumber }}</b-td>
                        <b-th>{{ $t('social_service.father_name_en') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.father_name }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.father_name_bn') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.father_name_bn }}</b-td>
                        <b-th>{{ $t('social_service.mother_name_en') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.father_name }}</b-td>
                        <b-th>{{ $t('social_service.mother_name_bn') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.father_name_bn }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.guardian_name_en') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.guardian_name }}</b-td>
                        <b-th>{{ $t('social_service.guardian_name_bn') }}</b-th>
                        <b-td>{{ followup_mains.patient_reg_mains.guardian_name_bn }}</b-td>
                        <b-th>{{ $t('social_service.relation_patient_en') }}</b-th>
                        <b-td>{{ followup_mains.relation }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.relation_patient_bn') }}</b-th>
                        <b-td>{{ followup_mains.relation_bn }}</b-td>
                    </b-tr>
              </b-table-simple>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.patient_adds') }}
                  </h5>
                </div>
              </template>
              <b-table-simple bordered>
                <b-tr>
                  <b-th>{{$t('globalTrans.division')}}</b-th>
                  <b-td>{{ getDivisionById(followup_mains.patient_reg_mains.division_id) }}</b-td>
                  <b-th>{{$t('globalTrans.district')}}</b-th>
                  <b-td>{{ getDistrictById(followup_mains.patient_reg_mains.district_id) }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{$t('educational_management.city_corporation')}}</b-th>
                  <b-td>{{ getCityCorporationById(followup_mains.patient_reg_mains.city_corporation_id) }}</b-td>
                  <b-th>{{$t('globalTrans.upazila')}}</b-th>
                  <b-td>{{ getUpazilaById(followup_mains.patient_reg_mains.upazilla_id) }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{$t('globalTrans.union')}}</b-th>
                  <b-td>{{ getUnionById(followup_mains.patient_reg_mains.union_id) }}</b-td>
                  <b-th>{{$t('educational_management.ward')}}</b-th>
                  <b-td>{{ getPauroshobaById(followup_mains.patient_reg_mains.pauroshoba_id) }}</b-td>
                </b-tr>
              </b-table-simple>
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                  <h5 class="text-white text-center">
                    {{ $t('social_service.ac_tk_p_impr_c_s') }}
                  </h5>
                </div>
              </template>
                <b-table-simple bordered>
                  <tr>
                    <th>{{$t('social_service.action_taken_en')}}</th>
                    <th>{{$t('social_service.action_taken_bn')}}</th>
                    <th>{{$t('social_service.follow_prograss_situation_en')}}</th>
                    <th>{{$t('social_service.follow_prograss_situation_bn')}}</th>
                  </tr>
                  <b-tr v-for="(action) in followup_mains.followup_actions" :key=action.id>
                    <b-td>{{ action.action }}</b-td>
                    <b-td>{{ action.action_bn }}</b-td>
                    <b-td>{{ action.follow_progress }}</b-td>
                    <b-td>{{ action.follow_progress_bn }}</b-td>
                  </b-tr>
                </b-table-simple>
                <template>
                    <div style="font-size:18px; background-color: #005B5B;">
                        <h5 class="text-white text-center"> {{ $t('social_service.other_information') }}
                        </h5>
                    </div>
                </template>
                <b-table-simple bordered>
                    <b-tr>
                        <b-th>{{ $t('social_service.other_relavant_en') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.other_info }}</b-td>
                        <b-th>{{ $t('social_service.other_relavant_bn') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.other_info_bn }}</b-td>
                        <b-th>{{ $t('social_service.comment_patient_en') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.patient_comment }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.comment_patient_bn') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.patient_comment_bn }}</b-td>
                        <b-th>{{ $t('social_service.comment_guardian_en') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.guardian_comment }}</b-td>
                        <b-th>{{ $t('social_service.comment_guardian_bn') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.guardian_comment_bn }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.comment_welfare_en') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.social_officer_comment }}</b-td>
                        <b-th>{{ $t('social_service.comment_welfare_bn') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.social_officer_comment_bn }}</b-td>
                        <b-th>{{ $t('social_service.recomnd_patient_en') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.recommendation }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.recomnd_patient_bn') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.recommendation_bn }}</b-td>
                        <b-th>{{ $t('social_service.case_close_date') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.case_closing_date | dateFormat }}</b-td>
                        <b-th>{{ $t('social_service.follow_ofc_name_en') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.follower_off_name }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('social_service.follow_ofc_name_bn') }}</b-th>
                        <b-td>{{ followup_mains.followup_others.follower_off_name_bn }}</b-td>
                    </b-tr>
                </b-table-simple>
                <template>
                    <div style="font-size:18px; background-color: #005B5B;">
                        <h5 class="text-white text-center">
                            {{ $t('social_service.docu') }}
                        </h5>
                    </div>
                </template>
                <b-table-simple bordered>
                  <tr>
                    <th>{{$t('social_service.document_name_en')}}</th>
                    <th>{{$t('social_service.document_name_bn')}}</th>
                    <th>{{$t('social_service.upload')}}</th>
                  </tr>

                  <template v-for="(attachedFile) in followup_mains.followup_docs">
                    <b-tr :key="attachedFile.id">
                      <b-td>{{ attachedFile.document_title }}</b-td>
                      <b-td>{{ attachedFile.document_title_bn }}</b-td>
                      <b-td>
                        <a :href="hospitalServiceBaseUrl + 'download-attachment?file=' + attachedFile.attachment" target="_blank" v-if="attachedFile.id > 0">
                          {{ attachedFile.attachment.split('/').pop() }}
                          <i class="ri-download-cloud-line" ></i>
                        </a>
                      </b-td>
                    </b-tr>
                  </template>

                </b-table-simple>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import Custom from '../../../../../../store/custom'
import ExportPdf from './export-pdf_details'

export default {
  props: ['id', 'hospitalServiceBaseUrl'],
  created () {
    if (this.id) {
      const tmp = this.getFollowupData()
      this.followup_mains = tmp
    }
  },
  data () {
    return {
      followup_mains: {}
    }
  },
  methods: {
    getFollowupData () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
      return JSON.parse(JSON.stringify(tmpData))
    },
    getAreaTypeById (id) {
      const tmp = Custom.wardTypeList.find(item => item.id === id)
      if (this.$i18n.locale === 'en') {
          return tmp.name
      } else {
          return tmp.name_bn
      }
    },
    getDivisionById (id) {
      const tmp = this.$store.state.commonObj.divisionList.find(item => item.value === id)
      return tmp ? tmp.text : ''
    },
    getDistrictById (id) {
      const tmp = this.$store.state.commonObj.districtList.find(item => item.value === id)
      return tmp ? tmp.text : ''
    },
    getCityCorporationById (id) {
      const tmp = this.$store.state.commonObj.cityCorporationList.find(item => item.value === id)
      return tmp ? tmp.text : ''
    },
    getUpazilaById (id) {
      const tmp = this.$store.state.commonObj.upazilaList.find(item => item.value === id)
      return tmp ? tmp.text : ''
    },
    getUnionById (unionId) {
      const tmp = this.$store.state.commonObj.unionList.find(item => item.value === unionId)
      return tmp ? tmp.text : ''
    },
    getPauroshobaById (pauroshobaId) {
      const tmp = this.$store.state.commonObj.pauroshobaList.find(item => item.value === pauroshobaId)
      return tmp ? tmp.text : ''
    },
    pdfExport () {
      const reportTitle = this.$t('report.followup_details_report')
      ExportPdf.exportPdfDetails(this.hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.followup_mains, this)
    }
  }
}
</script>
